module.exports = __webpack_public_path__ + "images/category_lp/pc/customer2_e08edf08fb85e935f1b385ec54b263f0.jpg";